import type { CSSProperties, ReactNode } from 'react';
import estilos from './Badge.module.css';

interface BadgeProps {
  children: ReactNode;
  /** Color pleno; el fondo se deriva de él. Acepta `var(--token)`. */
  color?: string;
  solido?: boolean;
  grande?: boolean;
  /** Punto de color a la izquierda del texto. */
  conPunto?: boolean;
  title?: string;
}

export function Badge({
  children,
  color = 'var(--text-2)',
  solido = false,
  grande = false,
  conPunto = false,
  title,
}: BadgeProps) {
  const estilo = { '--badge-color': color } as CSSProperties;

  return (
    <span
      className={[estilos.distintivo, solido ? estilos.solido : '', grande ? estilos.grande : '']
        .filter(Boolean)
        .join(' ')}
      style={estilo}
      title={title}
    >
      {conPunto && <span className={estilos.punto} aria-hidden />}
      {children}
    </span>
  );
}
